import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { Button } from "@circle-react-uikit/Button";

const ButtonWithMargin = ({ children, variant = "primary" }) => (
  <div className="mb-6">
    <Button full extraLarge variant={variant}>
      {children}
    </Button>
  </div>
);

export const LoginOptions = ({ formUrl, variant }) => {
  const {
    currentCommunity,
    currentCommunityPolicies,
    authProviderAuthorizationUrl,
    authProviderName,
    authProviderSignInWithCircleLinkLabel,
  } = useCurrentCommunityContext();

  const localeScope = `authentication_app.${variant}.options`;

  const showLoginButton =
    !currentCommunityPolicies.custom_login_enabled ||
    currentCommunityPolicies.customLoginAllowSignInWithCircle;

  const signInVariant = currentCommunity
    ? currentCommunityPolicies.custom_login_enabled
      ? "secondary"
      : "primary"
    : "marketing-gradient";

  let signInLabel;
  if (!currentCommunityPolicies.customLoginAllowSignInWithCircle) {
    signInLabel = t(`${localeScope}.email`);
  } else if (currentCommunity.white_label) {
    signInLabel = authProviderSignInWithCircleLinkLabel;
  } else {
    signInLabel = t(`${localeScope}.circle`);
  }

  return (
    <>
      {currentCommunityPolicies.custom_login_enabled && (
        <a href={authProviderAuthorizationUrl}>
          <ButtonWithMargin>
            {t(`${localeScope}.auth_provider`, {
              authProviderName: authProviderName,
            })}
          </ButtonWithMargin>
        </a>
      )}

      {showLoginButton && (
        <Link to={`${formUrl}#email`}>
          <ButtonWithMargin variant={signInVariant}>
            {signInLabel}
          </ButtonWithMargin>
        </Link>
      )}
      {currentCommunityPolicies?.showSocialLoginLinks && (
        <>
          <a
            href={authenticationAppRoutes.socialSignIn(
              "twitter",
              currentCommunity?.id,
            )}
            data-method="post"
          >
            <ButtonWithMargin variant="secondary">
              {t(`${localeScope}.twitter`)}
            </ButtonWithMargin>
          </a>
          <a
            href={authenticationAppRoutes.socialSignIn(
              "facebook",
              currentCommunity?.id,
            )}
            data-method="post"
          >
            <ButtonWithMargin variant="secondary">
              {t(`${localeScope}.facebook`)}
            </ButtonWithMargin>
          </a>
        </>
      )}
    </>
  );
};

ButtonWithMargin.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
};

LoginOptions.propTypes = {
  variant: PropTypes.oneOf(["signup", "signin"]),
  formUrl: PropTypes.string,
};
